<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="副仓：" v-if="subWarehouseList && subWarehouseList.length > 1">
            <el-select v-model="searchForm.SUB_WAREHOUSE" filterable placeholder="请选择副仓" clearable multiple collapse-tags style="width: 200px;">
              <el-option v-for="item in subWarehouseList" :key="item.ID" :label="item.AB_NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="供应商：">
            <el-select size="medium" filterable v-model="searchForm.TC_COMPANY" placeholder="请选择供应商" :clearable="true" @change="queryFirstTC()">
              <el-option v-for="(item, index) in companys" :key="index" :label="item.NAME" :value="item.SUPPLIER_ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单ID：">
            <el-input size="medium" v-model="searchForm.ORDER_ID"></el-input>
          </el-form-item>
          <el-form-item label="送货日期：">
            <el-date-picker size="medium" v-model="searchForm.SEND_DAY" type="date" placeholder="选择日期" :clearable="true">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="日期范围：">
            <el-date-picker size="medium" v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions2" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="整单备注：">
            <el-input size="medium" clearable v-model="searchForm.REMARKS" placeholder="请输入整单备注"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="doQueryTable()" :loading="loading">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button size="medium" @click="entryOrder" v-if="userPriceType == 1">手动录入</el-button>
        <el-button size="medium" type="primary" plain @click="exportOrderList">导出勾选订单</el-button>
        <el-button size="medium" type="primary" plain @click="亦芙德导出勾选订单()" v-show="fun_dic[100030113]">
          亦芙德导出勾选订单
        </el-button>
        <el-button size="medium" @click="exportOrder">导入订单</el-button>
        <el-button size="medium" @click="exportFeeOrder" v-if="userPriceType == 1">导入订单（总价导入）</el-button>
        <el-button size="medium" @click="exportFeeOrderNoWarehouse" v-show="fun_dic[100030101]" v-if="userPriceType == 1">
          导入订单（不进行入库）
        </el-button>
        <el-button size="medium" type="primary" plain @click="exportBatchOrder" v-if="fun_dic[100030109]">
          批量导出
        </el-button>
        <tooltip-button :disabled="Boolean(searchForm.DAY_INTERVAL && searchForm.DAY_INTERVAL[0])" tipContent="请先选择日期范围" buttonType="primary"
          buttonPlain buttonText="导出PDF" @click="pdfVisible = true">
        </tooltip-button>
        <tooltip-button :disabled="Boolean(checkedArrayExport[0])" tipContent="请先勾选订单" buttonType="primary" buttonPlain buttonText="勾选订单导出PDF"
          @click="pdfVisible = true">
        </tooltip-button>
        <tooltip-button v-if="fun_dic[100030111]" :disabled="Boolean(searchForm.SEND_DAY)" tipContent="请先选择送货日期" buttonType="primary" buttonPlain
          buttonText="汇总导出全部采购单" @click="summaryExportAll()">
        </tooltip-button>
        <tooltip-button :disabled="Boolean(checkedArrayExport[0])" v-if="fun_dic[100030115]" tipContent="请先勾选订单" buttonType="primary" buttonPlain
          buttonText="批量删除" @click="批量删除()">
        </tooltip-button>
      </el-col>
    </el-row>
    <el-dialog :visible.sync="exportOrderDialog" title="导入订单" width="400px" center>
      <el-form ref="orderForm" v-model="orderForm">
        <el-upload class="upload-demo" ref="upload" :on-remove="handleRemove" action="/uploadFile" :on-success="handleSuccess"
          :name="this.orderForm.orderName" multiple :limit="1" accept=".xls,.xlsx" :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过500kb</div>
        </el-upload>
        <p @click="downLoadOrder" style="color: #409EFF;margin-top: 20px;cursor: pointer">点击下载导入模板</p>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="exportOrderDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="handleExportOrder">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="exportFeeOrderDialog" title="导入订单（总价导入）" width="400px" center>
      <el-form ref="feeOrderForm" v-model="feeOrderForm">
        <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-remove="handleRemove" :on-success="handleSuccess"
          :name="this.feeOrderForm.orderName" multiple :limit="1" accept=".xls,.xlsx" :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过500kb</div>
        </el-upload>
        <p @click="downLoadFeeOrder" style="color: #409EFF;margin-top: 20px;cursor: pointer">点击下载导入模板</p>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="exportFeeOrderDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="handleExportFeeOrder">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="exportNoWarehouseDialog" title="导入订单（不进行入库）" width="400px" center>
      <el-form ref="feeOrderForm" v-model="NoWarehouseOrderForm">
        <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-remove="handleRemove" :on-success="handleSuccess"
          :name="this.NoWarehouseOrderForm.orderName" multiple :limit="1" accept=".xls,.xlsx" :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过500kb</div>
        </el-upload>
        <p @click="downLoadNoWarehouse" style="color: #409EFF;margin-top: 20px;cursor: pointer">点击下载导入模板</p>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="exportNoWarehouseDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="handleExportNoWarehouse">确认</el-button>
      </div>
    </el-dialog>
    <el-row>
      <el-col>
        <!-- 手动录入 -->
        <el-dialog title="选择订单信息" center :visible.sync="addFormVisible" width="600px">
          <el-form size="small" :model="addForm" ref="addForm" :rules="rules">
            <el-form-item label="供应商：" :label-width="formLableWidth" prop="customer">
              <el-select filterable v-model="addForm.customer" placeholder="请选择供应商" clearable style="width:80%" @change="queryProject()">
                <el-option v-for="item in customers" :key="item.SUPPLIER_ID" :label="item.NAME" :value="item.SUPPLIER_ID">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="送货日期：" :label-width="formLableWidth" prop="SEND_DAY">
              <el-date-picker v-model="addForm.SEND_DAY" clearable type="date" :picker-options="pickerOptions" placeholder="选择日期"
                value-format="yyyy-MM-dd" style="width:80%"></el-date-picker>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="close">取 消</el-button>
            <!-- <el-button size="small" v-if="this.addForm.customer === ''" disabled @click="submitAdd">确 定</el-button> -->
            <el-button size="small" @click="submitAdd('addForm')">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" border stripe show-summary :summary-method="getSummaries" style="width: 100%;margin-top:20px"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column prop="ORDER_ID" width="80" min-width="30" label="订单ID"></el-table-column>
          <el-table-column prop="ORDER_CODE" label="订单编号" min-width="130"></el-table-column>
          <el-table-column prop="SEND_DAY" label="送货日期" min-width="75"></el-table-column>
          <el-table-column prop="SUPPLIER_NAME" label="供应商" min-width="120"></el-table-column>
          <el-table-column prop="TOTAL_GYS_FEE" label="总价（元）" min-width="90"></el-table-column>
          <el-table-column prop="TOTAL_WEIGHT" label="总重" min-width="90"></el-table-column>
          <el-table-column prop="PRINT_TIME" label="打印次数" min-width="90"></el-table-column>
          <el-table-column prop="REMARKS" label="整单备注" min-width="90"></el-table-column>
          <el-table-column fixed="right" label="操作" min-width="170">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="detail(scope.row)">查看</el-button>
              <el-button type="text" size="small" @click="orderPrint(scope.row, 'print')" v-show="fun_dic[100030107]">
                打印
              </el-button>
              <el-button type="text" size="small" @click="orderPrint(scope.row, 'shortPrint')" v-show="fun_dic[100030108]">
                短打印
              </el-button>
              <el-button type="text" size="small" @click="check(scope.row)" v-show="fun_dic[100030106]">
                验收
              </el-button>
              <el-button type="text" size="small" @click="copyOrder(scope.row)">复制订单
              </el-button>
              <el-button type="text" size="small" @click="changeConfirm(scope.row)">转待确认</el-button>
              <!-- <el-button type="text" size="small" icon="el-icon-sort" @click="oneButton(scope.row)">一键转换</el-button> -->
              <el-button type="text" size="small" @click="orderContract(scope.row)">订单资质
              </el-button>
              <el-button type="text" size="small" @click="output(scope.row)">导出总计</el-button>
              <el-button type="text" size="small" @click="outPutDetail(scope.row)">导出详情
              </el-button>
              <el-button type="text" size="small" @click="outputDoc(scope.row)">导出入库单
              </el-button>
              <el-button type="text" size="small" @click="singleExportOrder(scope.row)">导出
              </el-button>
              <el-button type="text" size="small" @click="deleteOrder(scope.row)" style="color:#F56C6C">删除</el-button>
              <el-button type="text" size="small" @click="distributionCenterCheckDetail(scope.row)" v-show="fun_dic[100030103]">
                配送中心查看
              </el-button>
              <el-button type="text" size="small" @click="distributionCenterCheck(scope.row)" v-show="fun_dic[100030104]">
                配送中心验收
              </el-button>
              <el-button type="text" size="small" @click="修改订单(scope.row)" v-if="fun_dic[100030114]">
                修改订单
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <!-- 一键转换 -->
        <el-dialog title="选择订单信息" center :visible.sync="oneButtonVisible" width="600px">
          <el-form size="small" :model="oneForm" ref="oneForm">
            <el-form-item label="客户名称：">
              <el-select filterable v-model="oneForm.oneCustomer" style="width:80%" @change="queryOneProject()">
                <el-option v-for="item in oneCustomers" :key="item.ID" :label="item.AB_NAME" :value="item.ID">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="项目点：">
              <label slot="label">项&nbsp;目&nbsp;&nbsp;点：</label>
              <el-select filterable v-model="oneForm.project" style="width:80%" @change="queryOneDK()">
                <el-option v-for="item in projects" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="档口：">
              <label slot="label">档&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;口：</label>
              <el-select filterable v-model="oneForm.dkId" style="width:80%">
                <el-option v-for="item in dkList" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="送货日期：">
              <el-date-picker v-model="oneForm.SEND_DAY" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" style="width:80%"></el-date-picker>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="oneClose">取 消</el-button>
            <el-button size="small" @click="oneSubmit" v-if="this.oneForm.oneCustomer === '' || this.oneForm.project === ''" disabled>确 定</el-button>
            <el-button size="small" v-else @click="oneSubmit">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog title="目标供应商的部分商品没有报价" center :visible.sync="errorDialog" width="600px">
          <el-table :data="errorData" border>
            <el-table-column type="index" label="序号" width="50px"></el-table-column>
            <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
            <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
            <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          </el-table>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="errorDialog = false">确认</el-button>
          </div>
        </el-dialog>
        <el-dialog :title="printType == 'print' ? '打印' : '短打印'" center :visible.sync="realCountDialog" width="550px" @close="closeRealCountDialog">
          <el-form size="small" :model="exportDocForm" ref="orderPrintForm" :inline="true" :rules="rules">
            <el-form-item label="是否带实收：" label-width='150px'>
              <el-radio-group v-model="realCountRadio">
                <el-radio :label="1" style='margin-left: 25px'>是</el-radio>
                <el-radio :label="0" style='margin-left: 100px'>否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="printType == 'shortPrint'" label="是否带分类：" label-width='150px'>
              <el-radio-group v-model="catalogRadio">
                <el-radio :label="1" style='margin-left: 25px'>是</el-radio>
                <el-radio :label="0" style='margin-left: 100px'>否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="closeRealCountDialog">取 消</el-button>
            <el-button @click="print">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
    <!-- 单个订单导出PDF -->
    <el-dialog title="导出PDF" center :visible.sync="exportDocDialog" width="520px" :close-on-click-modal="false">
      <el-form size="small" :model="exportDocForm" ref="orderPrintForm" :inline="true" :rules="rules">
        <el-form-item label="是否带价格：" label-width='150px'>
          <el-radio v-model="exportDocForm.printPrice" label="0">不带价格</el-radio>
          <el-radio v-model="exportDocForm.printPrice" label="1">带价格</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="printClose">取 消</el-button>
        <el-button size="small" @click="submitexportDoc('exportDocForm')">确 定</el-button>
      </div>
    </el-dialog>
    <V-PurchaseOrderExportPDFForm :Visible="pdfVisible" :orderStatus="1" :startEnd="[...searchForm.DAY_INTERVAL]" :orderIds="[...checkedArrayExport]"
      @close="pdfVisible = false">
    </V-PurchaseOrderExportPDFForm>
    <download-excel style="z-index:-2;position:absolute;" id="download_excel" :data="excelpage" :fields="json_fields" :name="filename"
      :before-generate="startExport" :before-finish="finishExport">
      <el-button> 汇总导出全部采购单 </el-button>
    </download-excel>

    <el-dialog title="修改订单" center :visible.sync="修改订单模态框" width="500px" :close-on-click-modal="false">
      <el-form size="medium" :model="修改订单表单" ref="修改订单表单" :inline="true">
        <el-form-item label="供应商：" label-width='120px'>
          <el-select v-model="修改订单表单.SUPPLIER_ID" filterable placeholder="请选择供应商" clearable style="width: 300px;">
            <el-option v-for="item in companys" :key="item.SUPPLIER_ID" :label="item.NAME" :value="item.SUPPLIER_ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="送货日期：" label-width='120px'>
          <el-date-picker size="medium" v-model="修改订单表单.SEND_DAY" type="date" placeholder="选择日期" :clearable="true" style="width: 300px;">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="修改订单模态框 = false">取 消</el-button>
        <el-button size="small" @click="确认修改订单()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  queryEntryFun, addOrderFun, deleteOrderFun, copyOrderFun, exportOrderFun, exportOrderDetail, oneGYSFun,
  selectProjectFun, selectDKFun, oneSubmitFun, feeOrderExport, exportNewOrdeFun, exportSingleDocFunc, changeConfirm,
} from 'api/shopOrderManage';
import { getActionFun } from 'api/login';
import { queryActiveSupplierList } from 'api/customerManage';
import date from '@/assets/common/date';
import http from '@/assets/common/http';
import VPurchaseOrderExportPDFForm from './purchaseOrderExportPDFForm';
import util from '@/assets/common/util';

export default {
  data() {
    return {

      subWarehouseList: JSON.parse(sessionStorage.getItem('subWarehouseList')),
      修改订单表单: {},
      exportOrderDialog: false,
      fileList: [],
      file_name: '',
      orderForm: {
        orderName: 'tmp',
      },
      loading: false,
      // loading1: false,
      addFormVisible: false,
      oneButtonVisible: false,
      oneForm: {
        oneCustomer: '',
        project: '',
        SEND_DAY: '',
      },
      rules: {
        customer: [
          { required: true, message: '请选择供应商', trigger: 'blur' },
        ],
        SEND_DAY: [
          { required: true, message: '请选择送货日期', trigger: 'blur' },
        ],
      },
      addForm: {
        customer: '',
        project: '',
        SEND_DAY: date(new Date(), '%F'),
      },
      customers: [],
      projects: [],
      tableData: [],
      oneCustomers: [],
      currentPage: 1,
      totalCount: 0,
      pageSize: 20,
      searchForm: {
        DAY_INTERVAL: [],
      },
      companys: [],
      pickerOptions2: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          },
        }],
      },
      pickerOptions: {},
      flag: '',
      dkList: [],
      nameForm: {
        companyName: '',
      },
      nameFormVisible: false,
      formLableWidth: '100px',
      orderId: '',
      errorDialog: false,
      errorData: [],
      exportFeeOrderDialog: false,
      feeOrderForm: {
        orderName: 'tmp',
      },
      PAGE_ID: '1000301', // 页面ID 一旦规定不要轻易改动
      fun_dic: {
        100030101: 0, 100030103: 0, 100030104: 0, 100030106: 0, 100030107: 0, 100030108: 0, 100030109: 0, 100030111: 0, 100030112: 0, 100030113: 0, 100030114: 0, 100030115: 0,
      },
      exportNoWarehouseDialog: false,
      NoWarehouseOrderForm: {
        orderName: 'tmp',
      },
      // exportBatchVisible: false,
      // exportBatchForm: {},
      realCountDialog: false,
      realCountRadio: 0,
      printType: '',
      checkedArray: [],
      checkedArrayExport: [],
      exportDocDialog: false,
      exportDocForm: {
        printPrice: '0',
      },
      userPriceType: sessionStorage.getItem('PRICE_MODE'),
      catalogRadio: 0,
      pdfVisible: false,
      excelpage: [], // 存放用于导出excel的数据
      修改订单模态框: false,
      json_fields: {
        订单ID: 'ORDER_ID',
        供应商: 'SUPPLIER_NAME',
        总金额: 'PRODUCT_FEE',
        订单状态: 'STATUS',
        日期: 'DATE',
        整单备注: 'ORDER_COMMENT',
      },
      json_meta: [[{ key: 'charset', value: 'utf-8' }]],
      filename: '',
    };
  },
  components: {
    VPurchaseOrderExportPDFForm,
  },
  created() {
    this.queryBeforeFun();

    // 打印订单后筛选条件存在sessionStorage，如果有，获取后从sessionStorage移除
    if (sessionStorage.getItem('purchaseNewOrderListCondition')) {
      const condition = JSON.parse(sessionStorage.getItem('purchaseNewOrderListCondition'));
      this.searchForm = condition[0];
      this.currentPage = condition[1];
      sessionStorage.removeItem('purchaseNewOrderListCondition');
    }

    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.NEWORDER_SEARCH_DATA_CONDITION.CONDITION) {
      this.searchForm = this.NEWORDER_SEARCH_DATA_CONDITION.CONDITION;
      this.currentPage = this.NEWORDER_SEARCH_DATA_CONDITION.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryCustomer();
    this.queryOrderList();
    this.queryOneGYSData();
  },
  computed: {
    NEWORDER_SEARCH_DATA_CONDITION() {
      return this.$store.state.NEWORDER_SEARCH_DATA_CONDITION;
    },
  },
  methods: {
    批量删除() {
      const params = {
        SERVICE_ID: '10003',
        OTYPE: 8,
        ORDER_ID: this.checkedArrayExport,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((res) => {
        this.$message.show({ text: '删除成功', type: 'success' });
        this.queryOrderList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    确认修改订单() {
      const params = {
        SERVICE_ID: '10003',
        OTYPE: 57,
        ORDER_ID: this.修改订单表单.ORDER_ID,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        SUPPLIER_ID: this.修改订单表单.SUPPLIER_ID,
        SEND_DAY: date(this.修改订单表单.SEND_DAY, '%F'),
      };
      http.post(params).then((res) => {
        this.queryOrderList();
        this.$message.show({ text: '修改成功', type: 'success' });
        this.修改订单模态框 = false;
        this.修改订单表单 = {};
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    修改订单(row) {
      this.修改订单模态框 = true;
      this.修改订单表单.ORDER_ID = row.ORDER_ID;
    },
    // 汇总导出全部采购单
    summaryExportAll() {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 94,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        SEND_DAY: date(this.searchForm.SEND_DAY, '%F'),
      };
      if (this.searchForm.TC_COMPANY) {
        params.SUPPLIER_LIST = [this.searchForm.TC_COMPANY];
      }
      http.post(params).then((res) => {
        if (res.length !== 0) {
          this.filename = `汇总导出全部采购单${date(this.searchForm.SEND_DAY, '%F')}.xls`;
          this.excelpage = res;
          document.getElementById('download_excel').click();
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    startExport() {
    },
    finishExport() {
      this.$message.show({ text: '导出成功', type: 'success' });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (
          index === 1 || index === 2 || index === 7 || index === 8) {
          return;
        }
        const values = data.map((item) => Number(item[column.property])); // 总价列的数组
        if (!values.every((value) => Number.isNaN(value))) {
          // 判断当前列有无NaN  ，有则直接这一列合计为 '--'
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr); // 防止是字符串累加
            if (!Number.isNaN(value)) {
              return prev + value;
            }
            return prev;
          }, 0);
          sums[index] = sums[index].toFixed(2);
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
    orderContract(row) {
      this.$router.push({ name: 's_contantract', params: { id: row.ORDER_ID } });
      sessionStorage.setItem('menuName', 1);
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      this.file_name = '';
    },
    // 确认导入
    handleExportOrder() {
      const params = {
        SERVICE_ID: '10003',
        OTYPE: 55,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        FILE_NAME: this.file_name,
        PRICE_MODE: this.userPriceType,
      };
      if (!this.file_name) {
        this.$message.show({ text: '请先上传文件', type: 'warning' });
        return false;
      }
      http.post(params).then((res) => {
        if (!res[0].FILE_PATH) {
          this.queryOrderList();
          this.$message.show({ text: '导入成功', type: 'success' });
          this.file_name = '';
          this.$refs.upload.clearFiles();
          this.exportOrderDialog = false;
        } else {
          this.$message.show({ text: '导入失败', type: 'error' });
          this.file_name = '';
          this.$refs.upload.clearFiles();
          window.location.href = res[0].FILE_PATH;
          this.exportOrderDialog = false;
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
        this.file_name = '';
        this.$refs.upload.clearFiles();
      });
    },
    downLoadOrder() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/purchaseordertemp.xls';
    },
    handleSuccess(response, file, fileList) {
      this.file_name = response.file_name;
    },
    // 导入弹框
    exportOrder() {
      this.exportOrderDialog = true;
    },
    // -----------------------------------一键转换
    oneButton(row) {
      this.oneButtonVisible = true;
      this.oneForm.SEND_DAY = row.SEND_DAY;
      this.orderId = row.ORDER_ID;
    },
    // -----------------------------------一键转换确认按钮
    oneSubmit() {
      // 关账限制
      if (this.$util.isOrderClosed(this.oneForm.SEND_DAY)) {
        this.$message.show({ text: '该月份已关账，无法对此订单进行操作', type: 'warning' });
        return false;
      }
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            PURCHASE_ORDER_ID: Number(this.orderId),
            SEND_DAY: this.oneForm.SEND_DAY,
            TC_ID: Number(this.oneForm.oneCustomer),
            PROJECT_ID: this.oneForm.project,
            DK_ID: this.oneForm.dkId,
          };
          oneSubmitFun(params).then((result) => {
            this.$message.show({ text: '转换成功', type: 'success' });
            this.oneButtonVisible = false;
            this.oneForm = { oneCustomer: '', project: '', dkId: '' };
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    oneClose() {
      this.oneButtonVisible = false;
      this.oneForm = { oneCustomer: '', project: '' };
    },
    // -------------------------------------一键转换供应商
    queryOneGYSData() {
      oneGYSFun().then((result) => {
        if (result.length !== 0) {
          this.oneCustomers = result[0].company;
        } else {
          this.oneCustomers = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // --------------------------------------一键转换项目点
    queryOneProject() {
      const paramsProject = {
        TC_ID: Number(this.oneForm.oneCustomer),
      };
      selectProjectFun(paramsProject).then((result) => {
        if (result.length !== 0) {
          this.projects = result[0].list;
        } else {
          this.projects = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // ----------------------------------------一键转换选择档口
    queryOneDK() {
      const params = {
        PROJECT_ID: this.oneForm.project,
      };
      selectDKFun(params).then((res) => {
        this.dkList = res;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // --------------------------------------选择供应商
    queryFirstTC(e) {
      this.searchForm.TC_ID = e;
    },
    close() {
      this.addFormVisible = false;
      this.addForm.customer = '';
      this.queryOrderList();
    },
    entryOrder() {
      this.addFormVisible = true;
      this.flag = 0;
    },
    copyOrder(row) {
      this.addFormVisible = true;
      this.flag = 1;
      this.addForm.ORDER_ID = row.ORDER_ID;
    },
    exportBatchOrder() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10003',
            OTYPE: 41,
            GYS_ID: sessionStorage.getItem('tcId'),
          };
          if (this.searchForm.ORDER_ID) {
            params.ORDER_ID = this.searchForm.ORDER_ID;
          }
          if (this.searchForm.DAY_INTERVAL && this.searchForm.DAY_INTERVAL[0]) {
            params.START_DATE = this.searchForm.DAY_INTERVAL[0];
            params.END_DATE = this.searchForm.DAY_INTERVAL[1];
          }
          if (this.searchForm.TC_COMPANY) {
            params.SUPPLIER_ID = Number(this.searchForm.TC_COMPANY);
          }
          if (this.searchForm.SEND_DAY) {
            params.SEND_DAY = date(this.searchForm.SEND_DAY, '%F');
          }
          if (this.searchForm.SUB_WAREHOUSE && this.searchForm.SUB_WAREHOUSE[0]) {
            params.GYS_ID_LIST = this.searchForm.SUB_WAREHOUSE;
          }
          http.post(params).then((result) => {
            window.location.href = util.getURLLocalHost(result[0].FILE_PATH);
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    // ----------------------------- 手动录入
    submitAdd(formName) {
      // 关账限制
      if (this.$util.isOrderClosed(this.addForm.SEND_DAY)) {
        this.$message.show({ text: '该月份已关账，无法下单', type: 'warning' });
        return false;
      }
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          if (this.flag === 0) {
            this.$refs[formName].validate((valid) => {
              if (valid) {
                const params = {
                  SUPPLIER_ID: this.addForm.customer,
                  SEND_DAY: date(this.addForm.SEND_DAY, '%F'),
                };
                addOrderFun(params).then((result) => {
                  sessionStorage.setItem('orderCode', result[0].ORDER_CODE);
                  sessionStorage.setItem('orderId', result[0].ID);
                  sessionStorage.setItem('CAN_MODIFY_PRICE', result[0].CAN_MODIFY_PRICE);
                  sessionStorage.setItem('supplierId', this.addForm.customer);
                  this.$message.show({ text: '新增成功', type: 'success' });
                  this.$router.push({ path: '/s_addOrder/detail' });
                  document.body.style.cursor = 'default';
                }).catch((error) => {
                  this.$message.show({ text: error, type: 'error' });
                  document.body.style.cursor = 'default';
                });
              } else {
                document.body.style.cursor = 'default';
                return false;
              }
            });
          } else {
            this.$refs[formName].validate((valid) => {
              if (valid) {
                const params = {
                  SUPPLIER_ID: this.addForm.customer,
                  SEND_DAY: date(this.addForm.SEND_DAY, '%F'),
                  ORDER_ID: this.addForm.ORDER_ID,
                  PRICE_MODE: sessionStorage.getItem('PRICE_MODE'),
                };
                copyOrderFun(params).then((result) => {
                  if (result[0].ERROR_FLAG == 0) {
                    this.$message.show({ text: '复制成功', type: 'success' });
                    this.addFormVisible = false;
                  } else {
                    sessionStorage.setItem('supplierId', this.addForm.customer);
                    this.$message.show({ text: '复制失败', type: 'error' });
                    this.addFormVisible = false;
                    this.errorDialog = true;
                    this.errorData = result[0].DATA;
                  }
                  this.queryOrderList();
                  document.body.style.cursor = 'default';
                }).catch((error) => {
                  this.$message.show({ text: error, type: 'error' });
                  document.body.style.cursor = 'default';
                });
              } else {
                document.body.style.cursor = 'default';
                return false;
              }
            });
          }
        } finally { }
      }
    },
    // -------------------------------拉取供应商信息
    queryCustomer() {
      const params = {};
      if (this.addForm.customer) {
        params.SUPPLIER_NAME = this.addForm.customer;
      }
      queryActiveSupplierList(params).then((list) => {
        this.companys = list;
        this.customers = list;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    getDate() {
      const day = new Date();
      day.setTime(day.getTime() + 24 * 60 * 60 * 1000);
      const s = `${day.getFullYear()}-${day.getMonth() + 1}-${day.getDate()}`;
      this.addForm.SEND_DAY = s;
    },
    // ----------------------------------拉取供应商信息
    queryProject(e) {
      this.addForm.TC_ID = e;
    },
    // -----------------------------------筛选功能
    queryTable() {
      this.queryOrderList();
    },
    // -----------------------------------页码
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryOrderList();
    },
    // --------------------------------------进入页面拉取数据
    queryOrderList() {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.ORDER_ID) {
        params.ORDER_ID = this.searchForm.ORDER_ID;
      }
      if (this.searchForm.TC_COMPANY) {
        params.SUPPLIER_ID = Number(this.searchForm.TC_COMPANY);
      }
      if (this.searchForm.SEND_DAY) {
        params.SEND_DAY = date(this.searchForm.SEND_DAY, '%F');
      }
      if (this.searchForm.DAY_INTERVAL && this.searchForm.DAY_INTERVAL[0]) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      if (this.searchForm.REMARKS) {
        params.REMARKS = this.searchForm.REMARKS;
      }
      if (this.searchForm.SUB_WAREHOUSE && this.searchForm.SUB_WAREHOUSE[0]) {
        params.GYS_ID_LIST = this.searchForm.SUB_WAREHOUSE;
      }
      this.loading = true;
      queryEntryFun(params).then((result) => {
        if (result.length !== 0) {
          this.tableData = result[0].list;
          this.totalCount = result[0].TOTAL_COUNT;
          this.$store.dispatch('SET_NEWORDER_SEARCH_DATA_CONDITION', {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
          });
        } else {
          this.tableData = [];
          this.totalCount = 0;
        }
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    doQueryTable() {
      this.currentPage = 1;
      this.queryOrderList();
    },
    detail(row) {
      sessionStorage.setItem('orderId', row.ORDER_ID);
      sessionStorage.setItem('SEND_DAY', row.SEND_DAY);
      sessionStorage.setItem('orderCode', row.ORDER_CODE);
      sessionStorage.setItem('supplierId', row.SUPPLIER_ID);
      sessionStorage.setItem('CAN_MODIFY_PRICE', row.CAN_MODIFY_PRICE);
      this.$router.push({ path: '/s_addOrder/detail' });
    },
    // ---------------------------------------------验收
    check(row) {
      sessionStorage.setItem('orderId', row.ORDER_ID);
      sessionStorage.setItem('supplierID', row.SUPPLIER_ID);
      sessionStorage.setItem('orderId', row.ORDER_ID);
      sessionStorage.setItem('SEND_DAY', row.SEND_DAY);
      sessionStorage.setItem('orderCode', row.ORDER_CODE);
      sessionStorage.setItem('supplierId', row.SUPPLIER_ID);
      sessionStorage.setItem('CAN_MODIFY_PRICE', row.CAN_MODIFY_PRICE);
      this.$router.push({ path: '/s_orderCheck/detail' });
    },
    // ---------------------------------------------配送中心查看
    distributionCenterCheckDetail(row) {
      sessionStorage.setItem('orderId', row.ORDER_ID);
      sessionStorage.setItem('SEND_DAY', row.SEND_DAY);
      sessionStorage.setItem('orderCode', row.ORDER_CODE);
      sessionStorage.setItem('supplierId', row.SUPPLIER_ID);
      sessionStorage.setItem('CAN_MODIFY_PRICE', row.CAN_MODIFY_PRICE);
      this.$router.push({ path: '/s_distributionCenterPendingOrderDetail/detail' });
    },
    // ---------------------------------------------配送中心验收
    distributionCenterCheck(row) {
      sessionStorage.setItem('orderId', row.ORDER_ID);
      sessionStorage.setItem('supplierID', row.SUPPLIER_ID);
      sessionStorage.setItem('orderId', row.ORDER_ID);
      sessionStorage.setItem('SEND_DAY', row.SEND_DAY);
      sessionStorage.setItem('orderCode', row.ORDER_CODE);
      sessionStorage.setItem('supplierId', row.SUPPLIER_ID);
      sessionStorage.setItem('CAN_MODIFY_PRICE', row.CAN_MODIFY_PRICE);
      sessionStorage.setItem('IS_ACCEPT_BY_TC_QUANTITY', row.IS_ACCEPT_BY_TC_QUANTITY);
      this.$router.push({ path: '/s_distributionCenterOrderCheck/detail' });
    },
    // ----------------------------------------------删除订单
    deleteOrder(row) {
      this.$confirm('确定删除此订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          ORDER_ID: row.ORDER_ID,
        };
        deleteOrderFun(params).then((result) => {
          this.$message.show({ text: '删除成功', type: 'success' });
          this.queryTable();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }).catch(() => {
        this.$message.show({ type: 'info', text: '已取消删除' });
      });
    },
    // ----------------------------导出订单
    output(row) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            ORDER_ID: row.ORDER_ID,
          };
          exportOrderFun(params).then((result) => {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    outPutDetail(row) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            ORDER_ID: row.ORDER_ID,
          };
          exportOrderDetail(params).then((result) => {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    // 打印、短打印
    orderPrint(row, printType) {
      sessionStorage.setItem('orderId', row.ORDER_ID);
      this.realCountDialog = true;
      this.printType = printType;
    },
    print() {
      sessionStorage.setItem('realCountFlag', this.realCountRadio);
      this.closeRealCountDialog();
      // 订单打印后页面会刷新，将筛选条件存入sessionStorage
      sessionStorage.setItem('purchaseNewOrderListCondition', JSON.stringify([this.searchForm, this.currentPage]));

      if (this.printType === 'print') this.$router.push({ name: 's_orderPrint' });
      else {
        this.$router.push({ name: 'shortOrderPrint' });
        sessionStorage.setItem('catalogFlag', this.catalogRadio);
      }
    },
    closeRealCountDialog() {
      this.realCountRadio = 0;
      this.realCountDialog = false;
    },
    exportFeeOrder() {
      this.exportFeeOrderDialog = true;
    },
    handleExportFeeOrder() {
      const params = {
        FILE_NAME: this.file_name,
      };
      if (!this.file_name) {
        this.$message.show({ text: '请先上传文件', type: 'warning' });
        return false;
      }
      feeOrderExport(params).then((res) => {
        if (!res[0].FILE_PATH) {
          this.queryOrderList();
          this.$message.show({ text: '导入成功', type: 'success' });
          this.file_name = '';
          this.$refs.upload.clearFiles();
          this.exportFeeOrderDialog = false;
        } else {
          this.$message.show({ text: '导入失败', type: 'error' });
          this.file_name = '';
          this.$refs.upload.clearFiles();
          window.location.href = res[0].FILE_PATH;
          this.exportFeeOrderDialog = false;
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
        this.file_name = '';
        this.$refs.upload.clearFiles();
      });
    },
    downLoadFeeOrder() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/purchaseordertemp1.xls';
    },
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // 导入订单(不进行入库)
    exportFeeOrderNoWarehouse() {
      this.exportNoWarehouseDialog = true;
    },
    // 下载导入订单模板(不进行入库)
    downLoadNoWarehouse() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/pruchase_order_nh_import.xls';
    },
    // 确认导入(不进行入库)
    handleExportNoWarehouse() {
      const params = {
        SERVICE_ID: '10003',
        OTYPE: 27,
        GYS_ID: sessionStorage.getItem('tcId'),
        FILE_NAME: this.file_name,
      };
      http.post(params).then((res) => {
        if (!res[0].FILE_PATH) {
          this.queryOrderList();
          this.$message.show({ text: '导入成功', type: 'success' });
          this.file_name = '';
          this.$refs.upload.clearFiles();
          this.exportNoWarehouseDialog = false;
        } else {
          this.$message.show({ text: '导入失败', type: 'error' });
          this.file_name = '';
          this.$refs.upload.clearFiles();
          window.location.href = res[0].FILE_PATH;
          this.exportNoWarehouseDialog = false;
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
        this.file_name = '';
        this.$refs.upload.clearFiles();
      });
    },
    handleSelectionChange(val) {
      this.checkedArrayExport = val.map((item) => item.ORDER_ID);
    },
    亦芙德导出勾选订单() {
      const params = {
        iFlag: 1,
      };
      if (this.checkedArrayExport.length == 0) {
        this.$message.show({ text: '请选择订单', type: 'warning' });
        return false;
      }
      params.ORDER_IDS = this.checkedArrayExport;
      exportNewOrdeFun(params).then((result) => {
        window.location.href = util.getURLLocalHost(result[0].FILE_PATH);
        this.queryOrderList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    exportOrderList() {
      const params = {};
      if (this.checkedArrayExport.length == 0) {
        this.$message.show({ text: '请选择订单', type: 'warning' });
        return false;
      }
      params.ORDER_IDS = this.checkedArrayExport;
      exportNewOrdeFun(params).then((result) => {
        window.location.href = util.getURLLocalHost(result[0].FILE_PATH);
        this.queryOrderList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    printClose() {
      this.exportDocDialog = false;
    },
    // 导出送货单
    outputDoc(row) {
      this.exportDocForm.ID = row.ORDER_ID;
      this.exportDocDialog = true;
    },
    // 单个订单导出
    singleExportOrder(row) {
      const submitArr = [];
      submitArr.push(row.ORDER_ID);
      const params = {
        ORDER_IDS: submitArr,
      };
      exportNewOrdeFun(params).then((result) => {
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        this.queryOrderList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    submitexportDoc() {
      const params = {
        PRICE_FLAG: Number(this.exportDocForm.printPrice),
        ORDER_ID: this.exportDocForm.ID,
      };
      exportSingleDocFunc(params).then((result) => {
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        this.orderPrintDialog = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 转换为待确认
    changeConfirm(row) {
      const params = {
        ORDER_ID: row.ORDER_ID,
      };
      changeConfirm(params).then((result) => {
        this.$message.show({ text: '更新成功', type: 'success' });
        this.queryOrderList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/shopOrderManage/s_NewOrderList.vue